import axios from "axios";
import { Auth } from "aws-amplify";
import config from "config";

const apiClient = axios.create({
  baseURL: config.US_ADMIN_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(async (config) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${user.signInUserSession.idToken.jwtToken}`;
  } catch (err) {
    console.error("Error getting token", err);
  }
  return config;
});

export default apiClient;
